const toolTipData = [
  {
    id: "date",
    text: "Select Date."
  },
  {
    id: "locationId",
    text: "Select Location to Get the Users Attendance."
  },
  {
    id: "dataType",
    text: "Select Data Type."
  },
  {
    id: "Filter",
    text: "Search by Location Name."
  }
];

const listOfDepartment = [
  "ACCOUNTS & FINANCE",
  "ADMIN & SECURITY",
  "ADMIN",
  "ADMINISTRATION",
  "BOARD OF DIRECTORS",
  "BRIDGE CUTTING M/C",
  "BRIDGE CUTTING",
  "BRIGE CUTTING M/C",
  "C.N.C MACHINE",
  "DESIGN AND DEVELOPMENT",
  "DISPATCH",
  "ELECTRICAL",
  "FILLING PLANT",
  "FILTER PLANT",
  "FORK LIFT",
  "GANG SAW",
  "GANTRY",
  "GENERAL MAINTENANCE",
  "GUEST RELATION",
  "HUMAN RESOURCE",
  "HUMAN RESOURCES",
  "INFORMATION TECHNOLOGY",
  "ISO & SAFETY",
  "LAB",
  "LEGAL & COMPLIANCE",
  "LINER POLISH M/C",
  "LOGISTIC",
  "LOGISTICS & OPERATION",
  "MAINTENANCE",
  "MANAGEMENT",
  "MARBLE BLOCK PRODUCTION",
  "MARBLE SLAB POLISHING",
  "MARKETING COMMUNICATION",
  "OPERATION",
  "PROCUREMENT",
  "PRODUCTION & OPERATION",
  "PURCHASE",
  "QUALITY CONTROL",
  "QUARTZ SLAB POLISHING",
  "QUARTZ SLAB PRODUCTION",
  "RESEARCH & DEVELOPMENT",
  "RESIN LINE ",
  "RESIN LINE",
  "SALES & OPERATION",
  "SALES &DISTRIBUTION",
  "SALES-EXPORT",
  "SALES-SUPPORT",
  "SALES",
  "SAMPLE PHOTO",
  "SAMPLE",
  "SAMPLING",
  "SECURITY",
  "SHORT BLASTING",
  "SLAB PROCESS",
  "SPLITING M/C",
  "STOCK YARD (HAND POLISH)",
  "STOCK YARD",
  "STORE",
  "SUPER ADMIN",
  "TRAVEL DESK",
  "TROLLEY ",
  "TROLLY",
  "WATER JET M/C",
  "WEIGH BRIDGE"
];

export { toolTipData, listOfDepartment };
